<div class="selection-button">
    <div
        class="selection-button-container"
        [ngClass]="{
            'selection-button-container-selected': buttonInfo.selected,
            'selection-button-container-disabled': buttonInfo.disabled,
        }"
        (click)="buttonSelected()">
        <img class="button-icon" *ngIf="buttonInfo.iconPath" [src]="buttonInfo.iconPath" />
        <div class="button-text" *ngIf="buttonInfo.text" [ngClass]="{ 'button-text-selected': buttonInfo.selected }">
            {{ buttonInfo.text | beautifyDisplayString }}
        </div>
        <img class="button-selected-icon" *ngIf="buttonInfo.selected" src="assets/images/common/selected.svg" />
    </div>
    <div class="selection-button-description" *ngIf="buttonInfo.description">
        {{ buttonInfo.description | beautifyDisplayString }}
    </div>
</div>
